import React from "react";
import classNames from "classnames";
import { Link } from "react-router-dom";
import LoadingSvg from "../Icons/LoadingSvg";
import LogEvent from "../../../app/common/components/LogEventContainer";

export default function ButtonComponent({
  id,
  size = "base",
  href,
  label = "",
  startIcon = null,
  endIcon = null,
  disabled = false,
  onClick = null,
  active,
  isLoading = false,
  type = "button",
  form,
  children = null,
  block = false,
  stopEventBubbling = false,
  logImpression = false,
  logEventProps = {},
  classes = "",
  pill = false, //FIXME: Make a separate variant for pill
  ...props
}) {
  const loadingStateHeightClass = classNames({
    "h-6 w-6": ["base", "responsive-base"].includes(size),
  });

  const baseClass = `font-serif transition-colors items-center tracking-tight focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed disabled:shadow-none disabled:drop-shadow-none`;

  const pillStyle = pill
    ? {
        borderRadius: "36px",
      }
    : {};

  const renderButton = () => {
    return (
      <LogEvent
        logEventProps={logEventProps}
        actionProps={{ onClick: { action: "click" } }}
        elementType="button"
        logImpression={logImpression}
      >
        <button
          id={id}
          type={type}
          className={`${classes} ${baseClass}`}
          style={pillStyle}
          onClick={(event) => {
            if (stopEventBubbling) {
              event.stopPropagation();
            }
            if (onClick && !disabled) {
              onClick();
            }
          }}
          disabled={disabled || isLoading}
          active={active ? "true" : "false"}
          form={form}
          {...props}
        >
          {isLoading ? (
            <LoadingSvg className={loadingStateHeightClass} />
          ) : (
            <>
              {startIcon ? <span>{startIcon}</span> : null}
              <span>{label}</span>
              {children ? children : null}
              {endIcon ? <span>{endIcon}</span> : null}
            </>
          )}
        </button>
      </LogEvent>
    );
  };

  if (href) {
    return (
      <Link
        id={id}
        to={href}
        className={`flex items-center justify-center ${block ? "w-full" : ""}`}
        {...props}
      >
        {renderButton()}
      </Link>
    );
  }
  return renderButton();
}
